import SwitchInterestModule from './containers/switchInterestModule'

export {default as SwitchInterestModuleLayout} from './components/switchInterestModuleLayout'

export default SwitchInterestModule
